import { createAction } from "redux-actions";
import { CALL_API } from "../../middleware/api";
import { Actions } from "../actions/actions";

const showGuestlistSettings = createAction(Actions.Guestlist.GUESTLIST_SETTINGS_SHOW);
const hideGuestlistSettings = createAction(Actions.Guestlist.GUESTLIST_SETTINGS_HIDE);

const showAddGuestModal = createAction(Actions.Guestlist.GUEST_ADDING_MODAL_SHOW, (payload) => payload);
const hideAddGuestModal = createAction(Actions.Guestlist.GUEST_ADDING_MODAL_HIDE);

const setCurrentEditedGuestlistPlace = createAction(Actions.Guestlist.SET_CURRENT_EDITED_GUESTLIST_PLACE, (payload) => payload);
const setShowDeleteModal = createAction(Actions.Guestlist.SET_SHOW_DELETE_MODAL, (payload) => payload);

const setShowId = createAction(Actions.Guestlist.SET_SHOW_ID, (payload) => payload);
const setSearchState = createAction(Actions.Guestlist.SET_SEARCH_STATE, (payload) => payload);
const setDeleteGuestlistModal = createAction(Actions.Guestlist.SET_GUESTLIST_DELETE_MODAL, (payload) => payload);

const fetchGuestlist: any = (showId: number) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.GetGuestlistByShow(showId),
    types: [
      Actions.Guestlist.GUESTLIST_REQUEST,
      Actions.Guestlist.GUESTLIST_SUCCESS,
      Actions.Guestlist.GUESTLIST_FAILURE
    ]
  }
});

const addGuestlistPlace: any = (place: server.dto.LegacyGuestlistPlace) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.AddGuestlistPlace(place, place.guestlistId),
    types: [
      Actions.Guestlist.GUESTLIST_PLACE_ADD_REQUEST,
      Actions.Guestlist.GUESTLIST_PLACE_ADD_SUCCESS,
      Actions.Guestlist.GUESTLIST_PLACE_ADD_FAILURE
    ]
  }
});

const editGuestlistPlace: any = (place: server.dto.LegacyGuestlistPlace) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.UpdateGuestlistPlace(place),
    types: [
      Actions.Guestlist.GUESTLIST_PLACE_EDIT_REQUEST,
      Actions.Guestlist.GUESTLIST_PLACE_EDIT_SUCCESS,
      Actions.Guestlist.GUESTLIST_PLACE_EDIT_FAILURE
    ]
  }
});

const removeGuestlistPlace: any = (placeId: number) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.RemoveGuestlistPlace(placeId),

    types: [
      Actions.Guestlist.GUESTLIST_PLACE_REMOVE_REQUEST,
      Actions.Guestlist.GUESTLIST_PLACE_REMOVE_SUCCESS,
      Actions.Guestlist.GUESTLIST_PLACE_REMOVE_FAILURE
    ]
  }
});

const addGuest: any = (guest: server.dto.LegacyGuest, placeId: number) => ({
  [CALL_API]: {
    endpoint: async () =>
      window.Api.Guestlist.AddGuest(guest, placeId),
    types: [
      Actions.Guestlist.GUEST_ADD_REQUEST,
      Actions.Guestlist.GUEST_ADD_SUCCESS,
      Actions.Guestlist.GUEST_ADD_FAILURE
    ]
  }
});

const updateGuest: any = (guest: server.dto.LegacyGuest) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.UpdateGuest(guest),
    types: [
      Actions.Guestlist.GUEST_UPDATE_REQUEST,
      Actions.Guestlist.GUEST_UPDATE_SUCCESS,
      Actions.Guestlist.GUEST_UPDATE_FAILURE
    ]
  }
});

const removeGuest: any = (guestId: number) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.RemoveGuest(guestId),
    types: [
      Actions.Guestlist.GUEST_REMOVE_REQUEST,
      Actions.Guestlist.GUEST_REMOVE_SUCCESS,
      Actions.Guestlist.GUEST_REMOVE_FAILURE
    ]
  }
});

const addGuestlist: any = (showId: number) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.AddGuestlist(showId),
    types: [
      Actions.Guestlist.GUESTLIST_ADD_REQUEST,
      Actions.Guestlist.GUESTLIST_ADD_SUCCESS,
      Actions.Guestlist.GUESTLIST_ADD_FAILURE
    ]
  }
});

const removeGuestlist: any = (guestlistId: number) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.DeleteGuestlist(guestlistId),
    types: [
      Actions.Guestlist.GUESTLIST_DELETE_REQUEST,
      Actions.Guestlist.GUESTLIST_DELETE_SUCCESS,
      Actions.Guestlist.GUESTLIST_DELETE_FAILURE
    ]
  }
});

const showIdSet: any = (showId: number) => (dispatch) => {
  dispatch(setShowId(showId));
};

const updateGuestlist: any = (guestlist: server.dto.LegacyGuestlist) => ({
  [CALL_API]: {
    endpoint: async () => window.Api.Guestlist.UpdateGuestlist(guestlist),
    types: [
      Actions.Guestlist.GUESTLIST_UPDATE_REQUEST,
      Actions.Guestlist.GUESTLIST_UPDATE_SUCCESS,
      Actions.Guestlist.GUESTLIST_UPDATE_FAILURE
    ]
  }
});

const setSearchQuery: any = (query: string) => (dispatch) => {
  dispatch(setSearchState(query));
};

export {
  fetchGuestlist,
  showGuestlistSettings,
  hideGuestlistSettings,
  editGuestlistPlace,
  removeGuestlistPlace,
  addGuestlistPlace,
  addGuest,
  updateGuest,
  removeGuest,
  showAddGuestModal,
  hideAddGuestModal,
  addGuestlist,
  showIdSet,
  updateGuestlist,
  setCurrentEditedGuestlistPlace,
  setShowDeleteModal,
  setSearchQuery,
  removeGuestlist,
  setDeleteGuestlistModal
};
